import { forwardRef } from "react";
import TextareaAutosize, {
  TextareaAutosizeProps,
} from "react-textarea-autosize";
import { clsxm } from "@/utils/clsxm";

interface IProps extends TextareaAutosizeProps {}

const Textarea = forwardRef<HTMLTextAreaElement, IProps>(
  ({ className, ...props }, ref) => (
    <TextareaAutosize
      ref={ref}
      className={clsxm(
        "resize-none text-base leading-none text-black10 py-4 px-5 rounded-2xl border border-new-design-gray-600/[0.08] outline-none",
        "focus:border-purple-3 placeholder:!text-new-design-gray-500/50",
        className
      )}
      {...props}
    />
  )
);

export { Textarea };
